module.exports = __webpack_public_path__ + "img/country_smoked_ba_list.ff767444.jpg";